if (!customElements.get('recess-media-gallery')) {
  customElements.define('recess-media-gallery', class RecessMediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        productMediaDots: this.querySelector('.product__media-dots')
      }
      this.mql = window.matchMedia('(min-width: 750px)');

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();

      this.elements.productMediaDots.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.addEventListener('click', this.goToMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
    }

    onSlideChanged(event) {
      // debugger;

      const dot = this.elements.productMediaDots.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveDot(dot);
    }

    setActiveMedia(mediaId, currentVariantTitle, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`.product__media-item[data-media-id="${ mediaId }"]`);
      let tally = 1;
      this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]').forEach((element, idx) => {
        let altText = element.querySelector('img').alt.toLowerCase();
        let { mediaId } = element.dataset;

        let isActive = currentVariantTitle.toLowerCase().includes(altText);
        element.classList.toggle('is-active', isActive);
        this.elements.productMediaDots.querySelector(`[data-media-id="${mediaId}"]`).classList.toggle('is-active', isActive);

        if(isActive) {
          element.setAttribute('data-media-grid', `media${tally}`);
          tally++;
        } else {
          element.removeAttribute('data-media-grid');
        }
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.parentElement.scrollLeft = 0;
          activeMedia.parentElement.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      const dot = this.elements.productMediaDots.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveDot(dot);

      if (prepend) {
        this.elements.productMediaDots.prepend(dot);
      }
    }

    goToMedia(mediaId) {
      const activeMedia = this.elements.viewer.querySelector(`.product__media-item[data-media-id="${ mediaId }"]`);
      activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    setActiveDot(dot) {
      if (!this.elements.productMediaDots || !dot) return;

      this.elements.productMediaDots.querySelectorAll('.dot').forEach((element) => element.classList.remove('active'));
      dot.classList.add('active');
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
